module.exports = __webpack_public_path__ + "static/media/avatar_alligator.48f4ae08.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/avatar_alligator.png
// module id = 362
// module chunks = 0